import Cookies from 'js-cookie';
import axios from 'axios';
import { environment } from '@/env/env.prod';
import { clearClientSession } from '@/Auth/clearSiteSession';

const API_KEY = 'AIzaSyBdxIpFnajPcsqK2Dv1f8zuGCjcwBf9b5Q';
const REFRESH_INTERVAL = 50 * 60 * 1000;   // 1 hour in ms
const CHECK_INTERVAL = 5 * 60 * 1000;      // check every 5 minutes

// The Auth emulator proxies securetoken.googleapis.com under its own host —
// real tokens issued by the emulator aren't recognized by the real endpoint.
const TOKEN_ENDPOINT = environment.USE_EMULATORS
  ? 'http://127.0.0.1:9099/securetoken.googleapis.com/v1/token'
  : 'https://securetoken.googleapis.com/v1/token';

let _intervalId = null;

function getLastRefreshTime() {
  const ts = Cookies.get('refreshTokenTimestamp');
  return ts ? parseInt(ts, 10) : 0;
}

// [single-device-signin-test] Only these codes mean the refresh token
// itself is actually dead (revoked/disabled) - NOT a transient failure.
// A network blip or a 5xx from Google's own service should never force
// a logout, or a temporary hiccup would wrongly sign the user out. Same
// allowlist as the Flutter app's CheckTokenExpire.dart, for consistency.
const REVOKED_CODES = [ 'TOKEN_EXPIRED', 'INVALID_REFRESH_TOKEN', 'USER_DISABLED' ];

function forceLogout(reason) {
  console.warn('[single-device-signin-test] forcing logout:', reason);
  stopAuthRefresh();
  clearClientSession();
  window.location.href = '/login';
}

async function refreshAuthToken(refreshToken) {
  try {
    const response = await axios.post(
      `${TOKEN_ENDPOINT}?key=${API_KEY}`,
      new URLSearchParams({
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
      })
    );

    const { id_token, refresh_token } = response.data;
    Cookies.set('authToken', id_token);
    Cookies.set('refreshToken', refresh_token);
    Cookies.set('refreshTokenTimestamp', Date.now().toString());
  } catch (error) {
    const errorCode = error.response?.data?.error?.message;
    console.error('Token refresh failed:', errorCode || error.message);

    if (errorCode && REVOKED_CODES.some((code) => errorCode.includes(code))) {
      forceLogout(errorCode);
    }
    // anything else (network error, 5xx, unrecognized) - leave the
    // session alone, next scheduled refresh cycle will retry
  }
}

// Idempotent — safe to call multiple times; only one interval ever runs.
function startAuthRefresh() {
  if (_intervalId !== null) return;

  refreshAuthToken(Cookies.get('refreshToken'));

  _intervalId = setInterval(() => {
    const refreshToken = Cookies.get('refreshToken');
    const lastRefresh = getLastRefreshTime();
    if (refreshToken && (Date.now() - lastRefresh > REFRESH_INTERVAL)) {
      refreshAuthToken(refreshToken);
    }
  }, CHECK_INTERVAL);
}

// Call on sign-out to stop background refreshes.
function stopAuthRefresh() {
  if (_intervalId !== null) {
    clearInterval(_intervalId);
    _intervalId = null;
  }
}

export { startAuthRefresh, stopAuthRefresh };
